<ion-content class="ion-padding">
  <!-- Header -->
  <div class="flex items-center justify-between mb-[10px]">
    <div class="w-[44px] h-[44px] flex justify-center items-center bg-[#FFF3E6] rounded-full">
      <span class="material-symbols-outlined text-[#f28c28]">gavel</span>
    </div>
    <span (click)="close()" class="material-symbols-outlined">Close</span>
  </div>
  <div class="text-[20px] font-[700]">{{ 'TERM_AND_COMMISSION_UPDATE' | translate }}</div>
  <div class="policy-html" [innerHTML]="policyHtml"></div>
</ion-content>
<div class="commission px-[16px] pt-[16px]">
  <strong>
    {{ 'COMMISSION_RATE' | translate }}:
    <span class="text-[#f28c28]">{{ commissionRate }}%</span>
  </strong>
</div>

<ion-item lines="none" class="checkbox-item">
  <ion-checkbox slot="start" [(ngModel)]="accepted" (ngModelChange)="changAccepted($event)"></ion-checkbox>
  <ion-label>
    {{ 'COMMISSION_RATE_AGREE' | translate }}
  </ion-label>
</ion-item>

<div class="ion-padding" (click)="onSubmit()">
  <ion-button [disabled]="!accepted || loading" class="w-full text-base">
    {{ 'BUTTONS.ACCEPT_CONTINUE' | translate }}
  </ion-button>
</div>
